import SettingsContent from '../Wrapper';
import Index from './Index';
import Settings from './Settings';
import { frontendURL } from '../../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/virtual-assistants'),
      component: SettingsContent,
      props: params => {
        const showBackButton = params.name !== 'virtual_assistants_list';
        return {
          headerTitle: 'VIRTUAL_ASSISTANT_MGMT.HEADER',
          icon: 'robot',
          showNewButton: false,
          showBackButton,
        };
      },
      children: [
        {
          path: '',
          name: 'virtual_assistants_wrapper',
          roles: ['administrator', 'supervisor'],
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'virtual_assistants_list',
          roles: ['administrator', 'supervisor'],
          component: Index,
        },
        {
          path: ':assistentId',
          name: 'virtual_assistant_show',
          roles: ['administrator', 'supervisor'],
          component: Settings,
        },
      ],
    },
  ],
};
